import { ExamObservationModel, IExamObservationModel } from "./ExamObservationModel";
import { IModel, Model } from "./Model";

export interface IVisitExamResultObservationModel extends IModel {
    visitExamResultObservationId: number;
    visitExamResultId: number;
    examObservationId: number;
    examObservation: IExamObservationModel;
}

export class VisitExamResultObservationModel extends Model implements IVisitExamResultObservationModel {
    visitExamResultObservationId: number;
    visitExamResultId: number;
    examObservationId: number;
    examObservation: ExamObservationModel;

    constructor(params: IVisitExamResultObservationModel) {
        super(params);
        this.visitExamResultObservationId = params.visitExamResultObservationId;
        this.visitExamResultId = params.visitExamResultId;
        this.examObservationId = params.examObservationId;
        this.examObservation = new ExamObservationModel(params.examObservation)
    }
}
